module.exports = __webpack_public_path__ + "img/title-5.ce671137.png";